module.exports = __webpack_public_path__ + "static/media/shaolaishan3.eea46279.webp";